<template>
  <div class='homePage' id='homePage' ref='homePage'>
    <div class="login-btn" @click="goto('Login')" v-if="!userInfo">Login</div>
  </div>
</template>

<script>
import {mapMutations} from 'vuex'

export default {
  name: 'Home',
  components: {
  },
  data () {
    return {
      userInfo: JSON.parse(localStorage.getItem('userInfo'))
    }
  },
  watch: {},
  async mounted () {
  },
  beforeDestroy () {
  },
  methods: {
    ...mapMutations({
      setCurrentRoute: 'setCurrentRoute',
      setInternationName: 'setInternationName',
      setInternation: 'setInternation'
    }),
    goto (route) {
      this.$router.push(route)
    }
  }
}
</script>

<style lang='less' scoped>
.homePage {
  height: 100dvh;
  overflow: auto;
  position: relative;
  overflow-x: hidden;
  padding-bottom: 5vw;
  background: var(--background);

  .login-btn {
    margin: 50vw auto;
    width: calc(292vw / 3.6);
    height: calc(48vw / 3.6);
    background: var(--darkBlue);
    color: var(--white);
    border-radius: calc(12vw / 3.6);
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: calc(14vw / 3.6);
    font-weight: 500;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Home/index.vue